
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsX = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "icons-x_abcc48ff5469c1ad__a",
  width: "200%",
  height: "200%",
  x: "-50%",
  y: "-38.2%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 4,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0.859703075 0 0 0 0 0.87142499 0 0 0 0 0.876811594 0 0 0 0.412587413 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "icons-x_abcc48ff5469c1ad__d",
  width: "150.7%",
  height: "150.7%",
  x: "-25.3%",
  y: "-25.3%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceAlpha",
  result: "shadowBlurInner1",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 4,
  dy: 3,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic",
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowInnerInner1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
})), /*#__PURE__*/React.createElement("circle", {
  id: "icons-x_abcc48ff5469c1ad__b",
  cx: 17,
  cy: 17,
  r: 17
}), /*#__PURE__*/React.createElement("path", {
  id: "icons-x_abcc48ff5469c1ad__c",
  d: "m24.519 9.714-6.903 6.922-6.925-6.913-.977.949v.012l6.931 6.926-6.882 6.905.913.985h.015l6.91-6.936 6.906 6.901.994-.947v-.012l-6.929-6.917 6.892-6.92-.93-.955z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#icons-x_abcc48ff5469c1ad__a)",
  xlinkHref: "#icons-x_abcc48ff5469c1ad__b"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#icons-x_abcc48ff5469c1ad__b"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  fill: "var(--theme-primary, #810ea9)",
  xlinkHref: "#icons-x_abcc48ff5469c1ad__c"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#icons-x_abcc48ff5469c1ad__d)",
  xlinkHref: "#icons-x_abcc48ff5469c1ad__c"
})))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"34\" height=\"34\" viewBox=\"0 0 34 34\">\r\n    <defs>\r\n        <filter id=\"2a44qczgza\" width=\"200%\" height=\"200%\" x=\"-50%\" y=\"-38.2%\" filterUnits=\"objectBoundingBox\">\r\n            <feOffset dy=\"4\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"/>\r\n            <feGaussianBlur in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\" stdDeviation=\"5\"/>\r\n            <feColorMatrix in=\"shadowBlurOuter1\" values=\"0 0 0 0 0.859703075 0 0 0 0 0.87142499 0 0 0 0 0.876811594 0 0 0 0.412587413 0\"/>\r\n        </filter>\r\n        <filter id=\"osghfxl9td\" width=\"150.7%\" height=\"150.7%\" x=\"-25.3%\" y=\"-25.3%\" filterUnits=\"objectBoundingBox\">\r\n            <feGaussianBlur in=\"SourceAlpha\" result=\"shadowBlurInner1\" stdDeviation=\"2\"/>\r\n            <feOffset dx=\"4\" dy=\"3\" in=\"shadowBlurInner1\" result=\"shadowOffsetInner1\"/>\r\n            <feComposite in=\"shadowOffsetInner1\" in2=\"SourceAlpha\" k2=\"-1\" k3=\"1\" operator=\"arithmetic\" result=\"shadowInnerInner1\"/>\r\n            <feColorMatrix in=\"shadowInnerInner1\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0\"/>\r\n        </filter>\r\n        <circle id=\"5e226thf5b\" cx=\"17\" cy=\"17\" r=\"17\"/>\r\n        <path id=\"3hvrfx2qrc\" d=\"M24.519 9.714L17.616 16.636 10.691 9.723 9.714 10.672 9.714 10.684 16.645 17.61 9.763 24.515 10.676 25.5 10.691 25.5 17.601 18.564 24.507 25.465 25.501 24.518 25.501 24.506 18.572 17.589 25.464 10.669 24.534 9.714z\"/>\r\n    </defs>\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g>\r\n            <g>\r\n                <g>\r\n                    <g transform=\"translate(-322 -135) translate(10 128) translate(312 7)\">\r\n                        <use fill=\"#000\" filter=\"url(#2a44qczgza)\" xlink:href=\"#5e226thf5b\"/>\r\n                        <use fill=\"#FFF\" xlink:href=\"#5e226thf5b\"/>\r\n                    </g>\r\n                    <g transform=\"translate(-322 -135) translate(10 128) translate(312 7)\">\r\n                        <use fill=\"var(--theme-primary, #810ea9)\" xlink:href=\"#3hvrfx2qrc\"/>\r\n                        <use fill=\"#000\" filter=\"url(#osghfxl9td)\" xlink:href=\"#3hvrfx2qrc\"/>\r\n                    </g>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-x.abcc48ff5469c1ad9687c7cef6366406.svg"),
        {
          React: SvgIconsX,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      